import { ADVISOR_SESSION_FRAGMENT } from '@src/gql/fragments/AdvisorSessionFragment'
import { gql } from '@src/lib/gql'

export const REPORT_ADVISOR_SESSION_PRESENCE = gql`
  mutation ReportAdvisorSessionPresence($input: ReportAdvisorSessionPresenceInput!) {
    reportAdvisorSessionPresence(input: $input) {
      advisorSession {
        ...AdvisorSessionFragment
      }
    }
  }
  ${ADVISOR_SESSION_FRAGMENT}
`
